const CART_REDIRECT_STORAGE_KEY = 'bosp:open-cart-after-redirect';
const CART_REDIRECT_QUERY_PARAM = 'open_cart';
const CART_TRIGGER_SELECTOR = '[data-testid="cart-drawer-trigger"]';
const CANDYRACK_RETRY_DELAYS = [100, 300, 700, 1500, 3000, 5000];

function consumeRedirectMarker() {
  const url = new URL(window.location.href);
  const hasQueryMarker = url.searchParams.get(CART_REDIRECT_QUERY_PARAM) === 'true';
  let hasStorageMarker = false;

  try {
    hasStorageMarker = window.sessionStorage.getItem(CART_REDIRECT_STORAGE_KEY) === 'true';
    window.sessionStorage.removeItem(CART_REDIRECT_STORAGE_KEY);
  } catch (_) {
    // Storage can be unavailable in restricted browsing contexts. The query
    // marker used by the redirect is the fallback for those environments.
  }

  if (hasQueryMarker) {
    url.searchParams.delete(CART_REDIRECT_QUERY_PARAM);
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  }

  return hasStorageMarker || hasQueryMarker;
}

function openCartFromHeader() {
  const trigger = document.querySelector(CART_TRIGGER_SELECTOR);
  if (!(trigger instanceof HTMLButtonElement)) return false;

  trigger.click();
  return true;
}

function openCandyRackSlideCart() {
  const openCart = window.CandyRackSliderCart?.openCart;
  if (typeof openCart !== 'function') return false;

  openCart();
  return true;
}

function openCartWhenReady() {
  // Open Horizon immediately, then use CandyRack's public runtime API as soon
  // as its asynchronously loaded storefront script makes it available.
  openCartFromHeader();
  let candyRackOpened = openCandyRackSlideCart();

  for (const delay of CANDYRACK_RETRY_DELAYS) {
    window.setTimeout(() => {
      if (!candyRackOpened) candyRackOpened = openCandyRackSlideCart();
    }, delay);
  }
}

if (consumeRedirectMarker()) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openCartWhenReady, { once: true });
  } else {
    openCartWhenReady();
  }
}
